import { MouseEvent, useEffect, useRef, useState } from "react"

// A muted monospace entity id with a copy-to-clipboard icon that flips to a
// checkmark for a moment after copying. Clicks stop here — the Products rows
// navigate on click, and copying an id must not open the product.
export default function CopyableId({ id }: { id: string }) {
  const [copied, setCopied] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  useEffect(() => () => clearTimeout(timer.current), [])

  const handleCopy = (e: MouseEvent) => {
    e.stopPropagation()
    navigator.clipboard.writeText(id).then(() => {
      setCopied(true)
      clearTimeout(timer.current)
      timer.current = setTimeout(() => setCopied(false), 1500)
    }).catch(() => { })
  }

  return (
    <span
      onClick={(e) => e.stopPropagation()}
      style={{ display: "inline-flex", alignItems: "center", gap: 6, minWidth: 0 }}
    >
      <span style={{ fontSize: "9pt", color: "var(--nfa-light-grey)" }}>ID:</span>
      <span style={{ fontFamily: "var(--al-mono-font-family)", fontSize: "9pt", color: "var(--nfa-light-grey)", userSelect: "all", overflowWrap: "anywhere" }}>
        {id}
      </span>
      <button
        className="card-link"
        style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
        onClick={handleCopy}
        aria-label={copied ? "Copied" : "Copy ID"}
        title={copied ? "Copied" : "Copy ID"}
      >
        {copied ? (
          <svg width={13} height={13} viewBox="0 0 16 16" fill="currentColor" style={{ display: "block" }}>
            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
          </svg>
        ) : (
          <svg width={13} height={13} viewBox="0 0 16 16" fill="currentColor" style={{ display: "block" }}>
            <path fillRule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6ZM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1H2Z" />
          </svg>
        )}
      </button>
    </span>
  )
}
